var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92857 4C4.41708 4 3.92654 4.20319 3.56487 4.56487C3.20319 4.92654 3 5.41708 3 5.92857V17.5C3 18.0115 3.20319 18.502 3.56487 18.8637C3.92654 19.2254 4.41708 19.4286 4.92857 19.4286H19.0714C19.5829 19.4286 20.0735 19.2254 20.4351 18.8637C20.7968 18.502 21 18.0115 21 17.5V8.5C21 7.98851 20.7968 7.49797 20.4351 7.13629C20.0735 6.77462 19.5829 6.57143 19.0714 6.57143H11.0357L9.68571 4.77143C9.50607 4.53191 9.27313 4.3375 9.00534 4.2036C8.73755 4.06971 8.44226 4 8.14286 4H4.92857Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.20f14af54b928ac0aac7f163acb36389.svg";
export { ForwardRef as ReactComponent };